import { getClientTimeline } from 'features/timeline/ducks/timelineActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getClientNutritionPlans } from 'features/nutrition/ducks/nutritionActions';
import { getClientWorkouts } from 'features/work-out/ducks/workoutActions.js';
import { getLastLoggedWorkout } from 'features/clientProfile/components/workoutTab/ducks/clientProfileWorkoutActions';
import {
  getGraphsData,
  getClientTrack
} from 'features/clientProfile/components/progressTab/ducks/ProgressActions';
import Loader from 'features/Loader/Loader';
import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Timeline from 'features/timeline/components';
import NutritionTab from 'features/clientProfile/components/nutritionTab/NutritionTab';
import WorkoutTab from './workoutTab/WorkoutTab';
import Progress from './progressTab/Progress';
import Assessments from './assessmentTab/Assessments';

import Notes from './notesTab/Notes';
import { getClientWorkoutsOrder } from '../ducks/clientProfileActions';
import { getAssessments } from './assessmentTab/ducks/AssessmentActions';

const queryString = require('query-string');

const tabs = {
  timeline: 'timeline',
  workout: 'workout',
  nutrition: 'nutrition',
  progress: 'progress',
  notes: 'notes',
  assessments: 'assessments'
};

class ClientTabs extends React.Component {
  constructor(props) {
    super(props);
    const searchParams = queryString.parse(props.location.search);

    this.state = {
      activeTab: Object.keys(tabs).includes(searchParams.tab)
        ? searchParams.tab
        : tabs.timeline
    };
  }

  componentDidMount() {
    let { activeTab } = this.state;
    switch (activeTab) {
      case tabs.timeline:
        this.getTimeline();
        break;
      case tabs.workout:
        this.getWorkouts();
        break;
      case tabs.nutrition:
        this.getNutrition();
        break;
      case tabs.progress:
        this.getProgress();
        break;
      case tabs.assessments:
        this.getAssessments();
        break;
      default:
        this.getTimeline();
    }
  }

  getTimeline() {
    this.props.getClientTimeline(
      this.props.clientId,
      this.props.clientTimeline.lastVisible,
      false
    );
  }

  getNutrition() {
    this.props.getClientNutritionPlans(this.props.clientId);
  }

  getWorkouts() {
    let { clientId } = this.props;
    this.props.getClientWorkoutsOrder(clientId);
    this.props.getLastLoggedWorkout(clientId);
    this.props.getClientWorkouts(clientId);
  }

  getAssessments() {
    this.props.getAssessments(this.props.clientId);
  }

  getProgress() {
    let {
      clientId,
      getClientWorkouts,
      getGraphsData,
      getClientTrack
    } = this.props;
    getClientWorkouts(clientId);
    getGraphsData(clientId);
    getClientTrack(clientId);
  }

  handleLoadMore() {
    this.props.getClientTimeline(
      this.props.clientId,
      this.props.clientTimeline.lastVisible,
      true
    );
  }

  render() {
    const {
      clientTimeline,
      timelineLoading,
      client,
      notes,
      clientNutrition,
      clientId,
      clientWorkouts,
      assessments,
      clientWorkoutsOrder,
      lastLoggedWorkout,
      history
    } = this.props;

    return (
      <div className="client-profile-tabs">
        <Tab.Container
          defaultActiveKey={tabs.timeline}
          activeKey={this.state.activeTab}
          onSelect={activeTabKey => {
            this.setState({ activeTab: activeTabKey });
            history.push(`?tab=${activeTabKey}`);
          }}
          transition={false}
          id="clientProfileTab"
        >
          <Nav className="nav-tabs">
            <Nav.Item onClick={this.getTimeline.bind(this)}>
              <Nav.Link eventKey={tabs.timeline}>
                Timeline{/* <span className="count">2</span> */}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item onClick={this.getWorkouts.bind(this)}>
              <Nav.Link eventKey={tabs.workout}>Workout</Nav.Link>
            </Nav.Item>
            <Nav.Item onClick={this.getNutrition.bind(this)}>
              <Nav.Link eventKey={tabs.nutrition}>Nutrition</Nav.Link>
            </Nav.Item>
            <Nav.Item onClick={this.getProgress.bind(this)}>
              <Nav.Link eventKey={tabs.progress}>Progress</Nav.Link>
            </Nav.Item>
            <Nav.Item onClick={this.getAssessments.bind(this)}>
              <Nav.Link eventKey={tabs.assessments}>Assessments</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey={tabs.notes}>Notes</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey={tabs.timeline}>
              {!timelineLoading && clientTimeline ? (
                <Timeline
                  events={clientTimeline.events}
                  isClientTimeline={true}
                  enableLoadButton={clientTimeline.hasMore}
                  handleLoadMore={this.handleLoadMore.bind(this)}
                />
              ) : (
                <Loader />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey={tabs.workout}>
              {/* <WorkoutList workouts={[]} /> */}
              {clientWorkouts && lastLoggedWorkout && (
                <WorkoutTab
                  workouts={clientWorkouts}
                  clientId={clientId}
                  order={clientWorkoutsOrder}
                  clientWorkoutLastLogged={lastLoggedWorkout}
                />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey={tabs.nutrition}>
              <NutritionTab
                clientId={clientId}
                clientNutrition={clientNutrition}
              />
            </Tab.Pane>
            <Tab.Pane eventKey={tabs.progress}>
              <Progress workouts={clientWorkouts} clientId={clientId} />
            </Tab.Pane>
            <Tab.Pane eventKey={tabs.assessments}>
              {assessments && client && (
                <Assessments assessments={assessments} client={client} />
              )}
            </Tab.Pane>
            <Tab.Pane eventKey={tabs.notes}>
              <Notes client={client} notes={notes} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clientTimeline: state.timelineReducer.clientTimeline,
    timelineLoading: state.timelineReducer.loading,
    clientNutrition: state.nutritionReducer.clientNutrition,
    clientWorkouts: state.workoutReducer.clientWorkouts,
    assessments: state.assessmentsReducer.assessments,
    clientWorkoutsOrder: state.clientProfileReducer.clientWorkoutsOrder,
    lastLoggedWorkout: state.clientProfileWorkoutReducer.lastLoggedWorkout
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClientTimeline: (clientId, lastVisible, isLoadMore) =>
      dispatch(getClientTimeline(clientId, lastVisible, isLoadMore)),
    getClientNutritionPlans: clientId =>
      dispatch(getClientNutritionPlans(clientId)),
    getClientWorkouts: clientId => dispatch(getClientWorkouts(clientId)),
    getAssessments: clientId => dispatch(getAssessments(clientId)),
    getClientWorkoutsOrder: clientId =>
      dispatch(getClientWorkoutsOrder(clientId)),
    getLastLoggedWorkout: clientId => dispatch(getLastLoggedWorkout(clientId)),
    getGraphsData: clientId => dispatch(getGraphsData(clientId)),
    getClientTrack: clientId => dispatch(getClientTrack(clientId))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ClientTabs));
